// extracted by mini-css-extract-plugin
export default {"fullScreenTransparent":"Loading_fullScreenTransparent__TyFzx","fullScreenContent":"Loading_fullScreenContent__tS-zJ","loadingSpinner":"Loading_loadingSpinner__l0k4K"};